/*
 * @Desc: 预约租车管理接口
 * @Author: auto-generated
 * @Date: 2026-03-15
 */
import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/zucheCheInfo/list",
      method: "post",
      params: query,
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/zucheCheInfo/create",
      method: "post",
      data,
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/zucheCheInfo/edit",
      method: "post",
      data,
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/zucheCheInfo/detail",
      method: "post",
      params: query,
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/zucheCheInfo/remove",
      method: "post",
      data,
    });
  },
  // 状态
  status(data) {
    return request({
      url: "/zucheCheInfo/status",
      method: "post",
      data,
    });
  },
  // 排序
  sort(data) {
    return request({
      url: "/zucheCheInfo/sort",
      method: "post",
      data,
    });
  },
  // 下拉选
  select(query) {
    return request({
      url: "/zucheCheInfo/select",
      method: "get",
      params: query,
    });
  },
  // 日历数据
  riqidata(query) {
    return request({
      url: "/zucheCheRili/list",
      method: "post",
      params: query,
    });
  },
  // 日历数据
  riqidata15(query) {
    return request({
      url: "/zucheCheRili/list15",
      method: "post",
      params: query,
    });
  },
  // 创建日历预约
  createRiliOrder(data) {
    return request({
      url: "/zucheCheRili/create",
      method: "post",
      data,
    });
  },
  // 修改日历预约 
  editRiliOrder(data) {
    return request({
      url: "/zucheCheRili/edit",
      method: "post",
      data,
    });
  },
  // 删除日历预约
  removeRiliOrder(data) {
    return request({
      url: "/zucheCheRili/remove",
      method: "post",
      data,
    });
  },
  getCarListBydate(data) {
    return request({
      url: "/zucheCheInfo/getCarListBydate",
      method: "post",
      data,
    });
  } 
};
export default index;
